
type EventType = TranslationHistoryItem["eventType"];
type HistoryItem = { eventType: EventType; title?: string };

/** Returns true if there is at least one Approval event in the record history. */
export const isApproved = (history: HistoryItem[]): boolean =>
  history.some((item) => item.eventType === "Approved");

/** Returns true if the latest pending submission was produced by AI (InitialAI). */
export const isInitialAI = (history: HistoryItem[]): boolean => {
  // Look for an Initial event whose title matches: "Translated into {Lang} by Azure AI"
  const initialEvent = history.find(
    (item) => item.eventType === "InitialPublished" && !!item.title
  );
  if (!initialEvent?.title) return false;

  const title = initialEvent.title.trim().toLowerCase();
  const hasTranslatedPrefix = title.startsWith("Translated");
  const mentionsAzureAI = title.includes("by Azure AI");

  return hasTranslatedPrefix && mentionsAzureAI;
};
